<template>
<div id="pageOrder">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="page-header-right">
            <!-- Summary info -->
            <v-flex lg6 pa-0 pl-3 pt-3>
                <v-btn
                    :color="order.Status | order_status_color"
                    width="160px"
                    height="36px"
                    small
                    dark
                    depressed
                    outlined
                >{{ order.Status | order_status}}</v-btn>
            </v-flex>
            <!-- Action buttons -->
            <v-flex lg6 pa-0 pr-6 pt-6>
                <v-layout row wrap justify-end>
                    <v-btn @click="WaitPayOrder" v-if="order.Status == statusEnum.cho_bao_gia && (purchaseRole || adminRole)" color="red" dark>
                        Chờ đặt cọc
                    </v-btn>
                    <v-btn @click="backAmountVND = order.Deposit; dialogCancelOrder = true" v-if="(orderCancelable && ((orderRole & 2048)) || (adminRole && !canReorder)) && orderEditable.CheckPayment != 1" color="black" dark>
                        Hủy đơn
                    </v-btn>
                    <v-btn @click="ReOrder" v-if="canReorder && ((orderRole & 2048) || adminRole)">
                        Lên đơn
                    </v-btn>
                    <v-btn @click="DepositOrder" v-if="order.Status == statusEnum.cho_dat_coc && adminRole && !order.QuotationID" color="red" dark>
                        Đặt cọc
                    </v-btn>
                    <v-btn @click="CreateDeposit" color="blue" dark>
                        Ký gửi
                    </v-btn>
                    <v-btn @click="pushToXadal" :loading="pushingToXadal" v-if="(adminRole || purchaseRole) && (order.Status == statusEnum.da_dat_coc || order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || order.Status == statusEnum.da_mua_hang)" color="orange" dark class="ml-2">
                        Đẩy lên Xadal
                    </v-btn>
                    <order-flag-menu :orderID="orderId" :orderType="1"></order-flag-menu>
                    <!-- <order-widget-menu></order-widget-menu> -->
                </v-layout>
            </v-flex>
            <!-- Khach hang -->
            <v-flex v-if="orderWidgets.customer" v-bind:class="{ 'lg12': !orderWidgets.chat && orderWidgets.customer, 'lg6': orderWidgets.customer && orderWidgets.chat}">
                <v-widget :title="'#'+orderId">
                    <div slot="widget-header-action">
                        <h4 class="pl-2 pr-3 font-weight-bold">{{order.CreatedDate | display_date('DD-MM-YYYY HH:mm:ss') | capitalize}}</h4>
                    </div>
                    <div slot="widget-content" class="customer-info-box">
                        <v-card-text>
                            <v-layout row wrap pt-1>
                                <v-flex lg4 sm4>
                                    <v-card-title class="pa-0">Người đặt hàng</v-card-title>
                                </v-flex>
                                <v-flex lg8 sm8 pa-0>
                                    <v-row no-gutters>
                                        <span class="mt-6 account-toggle font-weight-bold text-red">{{customer.ID}}-{{customer.Username}}</span><v-spacer></v-spacer> <v-icon v-if="order.Status == statusEnum.cho_bao_gia || order.Status == statusEnum.cho_dat_coc" small @click="openDialogCustomerChange">fa-external-link-alt</v-icon>
                                        <v-chip color="red darken-2" text-color="white" small class="mr-1 mb-1" v-if="diffUID">
                                            Tồn tại mã vận đơn thuộc khách hàng khác
                                        </v-chip>
                                    </v-row>
                                    <v-row no-gutters v-if="adminRole || saleRole">
                                        <v-chip color="blue darken-2" text-color="white" small class="mr-1 mb-1">
                                            <a :href="customer.ContactID ? '/lead-manager/lien-he/'+customer.ContactID : '#'" target="_blank" style="color: #ffffff; text-decoration: none;">Chi tiết liên hệ</a>
                                        </v-chip>
                                        <v-chip color="green darken-2" text-color="white" small class="mr-1 mb-1">
                                            <a :href="'/khach-hang/quan-ly-khach-hang/'+customer.ID" target="_blank" style="color: #ffffff; text-decoration: none;">Chi tiết user</a>
                                        </v-chip>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                            <template v-if="(orderRole & 2)">
                                <v-layout row wrap pt-2>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Mua hàng</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select class="pa-0" :items="p_staffs" v-model="orderEditable.BuyerID" item-text="FullName" item-value="ID" :disabled="orderReadonly || !adminRole"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-1>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Sale nhập hàng</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select class="pa-0" :items="sale_staffs" v-model="orderEditable.SalerID" item-text="FullName" item-value="ID" :disabled="orderReadonly || !adminRole"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-1>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Nhân viên CS</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select class="pa-0" :items="cs_staffs" v-model="orderEditable.CustomerServiceID" item-text="FullName" item-value="ID" :disabled="orderReadonly || !adminRole"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-2>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Kho gửi</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select :disabled="orderReadonly || (!adminRole && order.Status == statusEnum.da_xuat_kho) || orderEditable.CheckPayment == 1" class="pa-0" :items="chinaStores" v-model="orderEditable.ChinaStoreID" item-text="Name" item-value="ID" item-disabled="IsHidden"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-2>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Kho nhận</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select :disabled="orderReadonly || (!adminRole && (order.Status == statusEnum.da_nhap_kho_nhan || order.Status == statusEnum.da_xuat_kho || order.Status == statusEnum.hoan_thanh)) || orderEditable.CheckPayment == 1" class="pa-0" :items="warehouses" v-model="orderEditable.ReceivePlaceID" item-text="Name" item-value="ID" item-disabled="IsHidden"></v-select>
                                        <span class="red--text pa-0 ma-0" v-if="order.RealStoreName">Đơn hàng về sai kho nhận</span>
                                        <span class="red--text pa-0 ma-0" v-else-if="order.WrongStore > 1">Đơn hàng có kiện không cùng kho nhận</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-2 v-if="order.WeChatId && order.WeChatId != ''">
                                    <v-flex lg4 md4>
                                        <v-card-title class="pa-0 font-weight-bold text-red">WeChat ID</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-text-field v-model="orderEditable.WeChatId" label="WeChat ID" ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-2>
                                    <v-flex lg4 md4>
                                        <v-card-title class="pa-0 font-weight-bold">Loại hàng</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select class="pa-0 font-weight-bold" :items="product_types" v-model="orderEditable.ProductType" item-text="name" item-value="value" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-select>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </v-card-text>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Danh gia don hang -->
            <v-flex v-if="orderWidgets.chat && (orderRole & 16)" v-bind:class="{ 'lg12': !orderWidgets.customer && orderWidgets.chat, 'lg6': orderWidgets.customer && orderWidgets.chat}">
                <v-widget title="Tin nhắn">
                    <!-- <div slot="widget-header-action">
                        <template v-for="item in allFlags" >
                            <v-tooltip top v-if="item.Checked" :key="item.ID">
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" medium :color="item.FlagColor" class="mr-3">flag</v-icon>
                                </template>
                                <span>{{item.FlagName}}</span>
                            </v-tooltip>
                        </template>
                    </div> -->
                    <div slot="widget-content">
                        <message-box :orderId="orderId" :orderType="1"></message-box>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Danh sách sản phẩm -->
            <v-flex sm12 md12 lg12 v-if="orderWidgets.product && (orderRole & 4)">
                <v-dialog v-model="dialogProduct" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Cập nhật sản phẩm</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field type="number" v-model="editedPro.quantity" label="Số lượng"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field type="number" step=".1" v-model="editedPro.price_promotion" label="Đơn giá"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-textarea rows="3" v-model="editedPro.comment" label="Ghi chú" class="input-group--focused"></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" dark @click="closeProductDialog">Đóng</v-btn>
                            <v-btn color="red darken-1" dark @click="saveProduct">Lưu lại</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogAppendProduct" max-width="1000px">
                    <v-card>
                        <v-card-title>
                        <span class="title">Thêm link sản phẩm</span>
                        </v-card-title>
                        <v-card-text>
                        <v-container grid-list-md pa-0>
                            <v-layout row wrap>
                            <v-flex lg12 md12 sm12 xs12>
                                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                                <v-list>
                                <v-list-item v-for="(item, index) in newProducts" :key="item.ID">
                                    <v-list-item-content>
                                    <v-flex lg2 md2 sm12 xs12>
                                    <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                                    </v-flex>
                                    <v-flex lg2 md2 sm12 xs12>
                                    <!-- <v-text-field label="Link ảnh" v-model="item.Image"></v-text-field> -->
                                    <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="`${getImages(index)}`" ref="imageFile"/>
                                    </v-flex>
                                    <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                                    </v-flex>
                                    <v-flex lg2 md2 sm12 xs12>
                                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                                    </v-flex>
                                    <v-flex lg2 md2 sm12 xs12>
                                    <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                                    </v-flex>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                    <v-btn icon @click="newProducts.splice(index, 1);">
                                        <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                </v-list>
                                <v-layout row wrap>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                                </v-flex>
                                <v-flex lg2 md2 sm12 xs12>
                                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image" ref="imageFile"/>
                                            </div>
                                            <div class="col-md-8">
                                                <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                                                <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                                </v-flex>
                                <v-flex lg1 md1 sm12 xs12>
                                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                                </v-flex>
                                <v-flex lg1 md1 sm12 xs12>
                                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                                </v-flex>
                                <v-flex lg1 md1 sm12 xs12>
                                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                                </v-flex>
                                </v-layout>
                            </v-flex>
                            </v-layout>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1 white--text" @click="dialogAppendProduct = false">Đóng</v-btn>
                        <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-widget title="Danh sách sản phẩm">
                    <div slot="widget-header-action">
                        <v-btn @click="appendProductShow" v-if="((productEditable && (orderEditRole & 4) && !orderReadonly) || adminRole) && orderEditable.CheckPayment != 1">
                            <v-icon color="red darken-3">fa-plus</v-icon> Thêm link
                        </v-btn>
                    </div>
                    <div slot="widget-content">
                        <v-data-table :headers="productHeader" :items="products" :mobile-breakpoint="100">
                            <template  v-slot:item="{ item }">
                                <tr @click="productSelectedIndex = item.index" @click.middle="productSelectedIndex = item.index" :class="productSelectedIndex === item.index ? 'product-highlight-row' : ''">
                                    <td>{{ item.index }}</td>
                                    <td>
                                        <a target="blank" :href="item.link_origin + '&hpo_id=' + item.item_id + '&hpo_oid=' + orderId">{{ item.ID }}</a>
                                    </td>
                                    <td>
                                        <img class="image-product" :src="proxyImage(item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin))" alt />
                                    </td>
                                    <td>{{ item.property }}</td>
                                    <td class="text-end">{{ item.quantity }}</td>
                                    <td class="text-end">{{ item.price_promotion | currency('¥', 2) }}</td>
                                    <td class="text-end">{{ item.quantity*item.price_promotion | currency('¥', 2) }}</td>
                                    <td class="text-center">
                                        <v-btn text icon color="red lighten-2" @click="editProduct(item)" v-if="((productEditable && (orderEditRole & 4) && !orderReadonly) || adminRole) && orderEditable.CheckPayment != 1">
                                            <v-icon small>fa-edit</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red lighten-2" @click="removeProduct(item)" v-if="((productEditable && (orderEditRole & 4) && !orderReadonly) || adminRole) && orderEditable.CheckPayment != 1">
                                            <v-icon small>fa-trash-alt</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="item.comment && item.comment !== ''">
                                    <td colspan="8" class="text-red"><b>Ghi chú: </b>{{ item.comment }}</td>
                                </tr>
                            </template>
                            <template v-slot:body.append>
                                <tr>
                                    <td colspan="4" class="font-weight-bold">Tổng tiền hàng</td>
                                    <td class="text-end font-weight-bold">{{totalProduct | currency}}</td>
                                    <td></td>
                                    <td class="text-end font-weight-bold">{{order.AmountCNY | currency('CNY', 2)}}</td>
                                    <td></td>
                                </tr>
                                <tr v-if="(orderRole & 256) || complainRole || csRole || internalRole">
                                    <td colspan="4" class="font-weight-bold">Phí ship nội địa</td>
                                    <td class="text-end font-weight-bold"></td>
                                    <td></td>
                                    <td class="text-end font-weight-bold">
                                        <h-currency-input :disabled="orderReadonly || !productEditable || !(orderEditRole & 64) || orderEditable.CheckPayment == 1" class="fee-cn-footer" v-model="feeShipCNY" :decimal="2" label="¥" @press_enter="manualUpdateDetail" @on_blur="manualUpdateDetail"></h-currency-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="font-weight-bold">Tổng cộng</td>
                                    <td class="text-end font-weight-bold"></td>
                                    <td></td>
                                    <td class="text-end font-weight-bold">{{order.AmountCNY + order.FeeShipCN | currency('CNY', 2)}}</td>
                                    <td></td>
                                </tr>
                                <tr v-if="(orderRole & 256) || realAmountRole">
                                    <td colspan="4" class="font-weight-bold">Tiền mua thật</td>
                                    <td class="text-end font-weight-bold"></td>
                                    <td></td>
                                    <td class="text-end font-weight-bold">
                                        <h-currency-input :rules="requireRealMoney" :disabled="internalRole || orderReadonly || !productEditable || !(orderEditRole & 128) || orderEditable.CheckPayment == 1" :decimal="2" class="fee-cn-footer" v-model="totalRealAmountCNY" label="¥" @press_enter="manualUpdateDetail" @on_blur="manualUpdateDetail"></h-currency-input>
                                    </td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Ma van don & don hang CN -->
            <v-flex sm12 md12 lg12 v-if="orderWidgets.transaction && (orderRole & 8)">
                <v-widget title="Mã vận đơn">
                    <div slot="widget-header-action">
                        <div v-if="missingPackage" class="missing-package-alert">
                            Thiếu kiện
                        </div>
                    </div>
                    <div slot="widget-content">
                        <div class="warning-internal" v-if="diffChinaStoreID">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Tồn tại mã vận đơn có kho gửi khác với kho gửi của đơn hàng
                        </div>
                        <order-transaction :currentOrder="order" :orderRealAmount="totalRealAmountCNY" :locked="orderLocked || orderEditable.CheckPayment == 1" :disabled="confirmPrice || orderNotDeposit || orderReadonly || !(orderEditRole & 8)"></order-transaction>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Chi phi don hang -->
            <v-flex sm12 md12 lg12 v-if="(!order.QuotationID && orderWidgets.paymentArea && (orderRole & 256)) || adminRole || paymentRole || saleRole">
                <v-widget title="Chi phí đơn hàng">
                    <div slot="widget-header-action" class="pt-6" v-if="!(order.QuotationID && saleRole)">
                        <v-checkbox :disabled="!adminRole && !paymentRole" class="pl-3" v-model="orderEditable.CheckPayment" label="Đã kiểm tra tài chính"></v-checkbox>
                    </div>
                    <div slot="widget-content">
                        <div class="warning-internal" v-if="order.WarningFeeWeightCommission">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Hãy xem xét lại giá bán, hệ thống phát hiện mức giá bán đáng ngờ so với giá niêm yết
                        </div>
                        <v-radio-group
                            v-model="extraOptions"
                            row
                            class="pa-0 pt-2"
                            :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole) || orderEditable.CheckPayment == 1"
                            v-if="!(order.QuotationID && saleRole)"
                            >
                            <v-radio
                                label="Theo cấp độ an toàn của hàng hóa."
                                value="safe-level"
                            ></v-radio>
                            <v-radio
                                label="Tùy chỉnh Bảo hiểm & Gia cố an toàn hàng"
                                value="optional"
                            ></v-radio>
                        </v-radio-group>
                        <v-layout row wrap>
                            <v-flex lg12 sm12 pa-0 ma-0 pr-2>
                                <template v-if="!(order.QuotationID && saleRole)">
                                    <v-layout row wrap v-if="extraOptions == 'optional'">
                                        <v-flex lg2 sm2 pa-0 pt-6 pl-6>
                                            <v-checkbox label="Dịch vụ đóng gỗ" v-model="orderEditable.IsFragileGoods" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6 pl-6>
                                            <v-checkbox label="Dịch vụ bọt khí" v-model="orderEditable.IsFoam" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6>
                                            <v-checkbox label="Dịch vụ kiểm hàng (gói A)" v-model="isCheckPackageA" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6>
                                            <v-checkbox label="Dịch vụ kiểm hàng (gói B)" v-model="isCheckPackageB" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg4 sm4 pb-0>
                                            <v-select label="Bảo hiểm hàng" v-model="orderEditable.GuaranteeType" :items="guarantees" item-text="PackageName" item-value="ID" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole && (order.Status == statusEnum.cho_dat_coc|| order.Status == statusEnum.cho_bao_gia || order.Status == statusEnum.da_dat_coc || order.Status == statusEnum.da_mua_hang || order.Status == statusEnum.dang_den_kho_gui))) || orderEditable.CheckPayment == 1"></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-else>
                                        <v-flex lg3 sm3 pa-0 pt-6 pl-6>
                                            <v-select label="Cấp độ an toàn" class="pa-0 font-weight-bold" clearable :items="safeLevels" v-model="orderEditable.SafeLevelID" item-text="Name" item-value="ID" item-disabled="HideOnAdmin" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                </template>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pb-0>
                                        <v-card-title>Tỷ giá</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pb-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.ExchangeRate" label="₫" :decimal="0" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pb-0>
                                        <v-card-title>Hoa hồng vận chuyển</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pb-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-bind:class="{'warning-amount': !orderEditable.FeeWeightCommission && order.WarningFeeWeightCommission}" v-model="orderEditable.FeeWeightCommission" :decimal="1" label="Hoa hồng vận chuyển (%)" :disabled="orderEditable.CheckPayment == 1 || !(adminRole || paymentRole)"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <v-checkbox class="pl-3" v-model="orderEditable.FixFeeWeightCommission" label="Fix hoa hồng" v-if="adminRole || paymentRole" :disabled="orderEditable.CheckPayment == 1"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg3 sm3 pb-0 pt-0>
                                        <v-card-title>Tổng giá</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                                        <v-card-title class="pl-0 font-weight-bold subheading">{{order.AmountCNY | currency('CNY', 2)}} ( {{order.AmountVND | currency}} )</v-card-title>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Tổng số tiền mua thật</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.TotalRealAmountCNY" label="¥" disabled></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="totalRealAmount" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Phí ship nội địa</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeShipCN" label="¥" :decimal="2" disabled></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeShipCNVND" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Kiểu tính phí vận chuyển</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pb-0 pl-2 pr-2>
                                                <v-select label="Kiểu tính phí" v-model="orderEditable.FeeShipType" :items="feeshiptypes" item-text="name" item-value="value" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></v-select>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2 pt-4>
                                                <v-card-title>Tổng cân: {{(totalWeight ? totalWeight : totalWeightByBigpackage) | currency('', 2)}}kg, Tổng khối: {{(totalVolume ? totalVolume : totalVolumeByBigpackage) | currency('', 2)}}m3</v-card-title>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Phí mua hàng (CK: {{orderEditable.FeeBuyDiscount | currency}}%)</v-card-title>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeBuy" :decimal="1" label="%" :disabled="(!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh)) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeBuyAmount" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="orderEditable.SafeLevelID && !(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí cấp độ an toàn</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="order.SafeLevelWeightAmount" label="đ" :decimal="0" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="red--text" row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Giá niêm yết</v-card-title>
                                        <v-checkbox class="pl-3" v-model="orderEditable.FixListedFeeWeight" label="Fix đơn giá niêm yết" v-if="adminRole || paymentRole" :disabled="orderEditable.CheckPayment == 1"></v-checkbox>
                                    </v-flex>
                                    <v-flex lg3 sm3 pt-0>
                                        <h-currency-input v-model="orderEditable.ListedFeeWeight" label="Đơn giá niêm yết (₫)" :decimal="0" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                    </v-flex>
                                    <v-flex lg3 sm3 pt-0>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-title>Phí vận chuyển (CK: {{orderEditable.FeeWeightDiscount | currency}}%)</v-card-title>
                                        <v-checkbox class="pl-3" v-model="orderEditable.IsUpdateFeeShip" label="Fix đơn giá vận chuyển" v-if="adminRole || paymentRole || (purchaseRole && csRole)" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                    </v-flex>
                                    <v-flex lg3 sm3 pt-0>
                                        <h-currency-input v-model="orderEditable.FeeWeight" label="Đơn giá (₫)" :decimal="0" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                        <span class="red--text" v-if="warningFeeWeight">Hãy xem xét lại giá bán có cộng các phí khác vào không?</span>
                                    </v-flex>
                                    <v-flex lg3 sm3 pt-0 pl-2 pr-2>
                                        <h-currency-input v-model="order.OrderWeight" :decimal="2" :label="order.FeeShipType == 0 ? 'kg' : order.FeeShipType == 1 ? 'm3' : 'kg(quy đổi)'" disabled></h-currency-input>
                                    </v-flex>
                                    <v-flex lg3 sm3 pa-0 pl-2 pr-2>
                                        <h-currency-input v-model="order.FeeWeightAmount" :decimal="0" label="₫" disabled></h-currency-input>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí ship tận nhà</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeShipVN" :decimal="0" label="₫" :disabled="(existExported && !adminRole)"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Chi phí phát sinh</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="order.TotalOtherFee" label="₫" :decimal="0" disabled></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2 pt-2>
                                                <v-btn color="blue darken-1" outlined @click="openOtherFeePopup">Chi tiết</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí khác</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FeeOther" label="₫" :decimal="0" :disabled="!(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole || purchaseRole || storeVNRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <v-text-field v-model="orderEditable.FeeOtherNote" label="Ghi chú" class="input-group--focused" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="orderEditable.IsFragileGoods && !(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí đóng gỗ</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FragileFee" label="¥" :decimal="1" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                <v-checkbox class="pt-6" v-model="orderEditable.FixFragileFee" label="Fix đơn giá" v-if="adminRole || paymentRole || (purchaseRole && csRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FragileFeeVND" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="orderEditable.IsFoam && !(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí bọt khí</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FoamFee" label="¥" :decimal="1" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                <v-checkbox class="pt-6" v-model="orderEditable.FixFoamFee" label="Fix đơn giá" v-if="adminRole || paymentRole || (purchaseRole && csRole) || orderEditable.CheckPayment == 1"></v-checkbox>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.FoamFeeVND" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="orderEditable.IsCheck && !(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí kiểm hàng</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <!-- <h-currency-input v-model="orderEditable.CheckFee" label="¥" :decimal="1" :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"></h-currency-input> -->
                                                <h-currency-input v-model="orderEditable.CheckFeeVND" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text" row wrap v-if="orderEditable.GuaranteeType > 0 && !(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0>
                                        <v-card-text>Phí bảo hiểm</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0>
                                        <v-layout row wrap>
                                            <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.GuaranteeAmountVND" label="₫" :decimal="0" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                <v-checkbox class="pt-6" v-model="orderEditable.FixGuaranteeFee" label="Fix đơn giá" v-if="adminRole || paymentRole"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="purple--text font-weight-bold" v-if="order.MinDepositRequest >= 0 && orderNotDeposit">
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Đề xuất cọc (chờ duyệt)</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <h-currency-input v-model="order.MinDepositRequest" :decimal="0" label="₫" :disabled="true"></h-currency-input>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="black--text font-weight-bold">
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Tiền cần cọc</v-card-text>
                                    </v-flex>
                                    <v-flex lg6 sm6 pt-0 pb-0>
                                        <h-currency-input :disabled="!(adminRole || paymentRole) || order.Deposit > 0 || orderEditable.CheckPayment == 1" v-model="orderEditable.MinDeposit" :decimal="0" label="₫"></h-currency-input>
                                    </v-flex>
                                    <v-flex lg3 sm3 pt-0 pb-0 v-if="orderNotDeposit">
                                        <v-dialog v-model="dialogDeposit" max-width="500px">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">Đề xuất tiền cọc</span>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-container grid-list-md>
                                                        <v-layout wrap>
                                                            <v-flex xs12 sm6 md4>
                                                                <h-currency-input v-model="MinDepositRequest" :decimal="0" label="Số tiền đề xuất"></h-currency-input>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="dialogDeposit = false">Đóng</v-btn>
                                                    <v-btn color="blue darken-1 white--text" @click="orderEditable.MinDepositRequest = MinDepositRequest; MinDepositRequest = null; dialogDeposit = false">Đề xuất</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <v-btn v-if="!(adminRole || paymentRole) && (orderEditable.MinDepositRequest == null || orderEditable.MinDepositRequest == -1)" color="blue-grey" class="ma-2 white--text" @click="depositRequest">Đề xuất<v-icon right dark>fa-user-check</v-icon></v-btn>
                                        <v-btn v-if="!(adminRole || paymentRole) && orderEditable.MinDepositRequest >= 0" color="blue-grey" class="ma-2 white--text" @click="orderEditable.MinDepositRequest = -1">Hủy đề xuất<v-icon right dark>fa-user-check</v-icon></v-btn>
                                        <v-btn v-if="adminRole && orderEditable.MinDepositRequest >= 0" color="blue-grey" class="ma-2 white--text" @click="orderEditable.MinDeposit = orderEditable.MinDepositRequest; orderEditable.MinDepositRequest = -1">Phê duyệt<v-icon right dark>fa-user-check</v-icon></v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="blue--text font-weight-bold" row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Voucher</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="order.VoucherAmount" :decimal="0" label="Số tiền giảm" readonly></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6  pa-0 pl-2 pr-2 pt-2>
                                                <v-btn color="blue darken-1" outlined @click="voucherPopup = true" :disabled="!(order.Status == 7 || (order.Status == 9 && order.TotalAmountVND > order.Deposit) || adminRole) || lockedOrder || orderEditable.CheckPayment == 1">Chọn voucher</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Chiết khấu phí dịch vụ</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="order.TotalDiscount" :decimal="0" label="Chiết khấu phí dịch vụ" disabled></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!(order.QuotationID && saleRole)">
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Giảm trừ đơn hàng</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="orderEditable.DiscountVND" :decimal="0" label="Giảm trừ đơn hàng" :disabled="!(adminRole || paymentRole || (saleRole && (order.Status == 3 || order.Status == 0))) || orderEditable.CheckPayment == 1"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Tổng cộng</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <h-currency-input v-model="order.TotalAmountVND" :decimal="0" label="₫" disabled></h-currency-input>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg3 sm3 pt-0 pb-0>
                                        <v-card-text>Đã thanh toán</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9 pt-0 pb-0>
                                        <h-currency-input v-model="orderEditable.Deposit" :decimal="0" label="₫" :disabled="!(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole)) || orderEditable.CheckPayment == 1"></h-currency-input>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="red--text font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Cần thanh toán</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <h-currency-input showClass="red--text" v-model="remainAmount" :decimal="0" label="₫" disabled></h-currency-input>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Lich su thanh toan  && (orderRole & 32)-->
            <v-flex sm12 md12 lg12 v-if="orderWidgets.paymentHistory">
                <v-widget title="Lịch sử thanh toán">
                    <div slot="widget-content">
                        <v-data-table :headers="paymentHistoryHeader" :items="order.PaymentHistory" :mobile-breakpoint="100" :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }" :items-per-page="10">
                            <template  v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.CreatedDate | display_date }}</td>
                                    <td v-bind:style="{ 'color': get_type_color(item.Status, payment_status)}">{{ item.Status | display_value(payment_status) }}</td>
                                    <td>{{ item.Type | payment_method }}</td>
                                    <td class="text-end">{{ item.Amount | currency }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Lich su khieu nai -->
            <v-flex sm12 md12 lg12 v-if="orderWidgets.complain">
                <v-widget title="Lịch sử khiếu nại">
                    <div slot="widget-content">
                        <v-data-table :headers="paymentComplainHeader" :items="order.OrderComplains" :mobile-breakpoint="100" :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }" :items-per-page="10">
                            <template  v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.ID}}</td>
                                    <td class="text-end">{{ item.Amount | currency}}</td>
                                    <td>{{ item.ComplainText}}</td>
                                    <td>{{ item.CreatedDate | display_date }}</td>
                                    <td>
                                        <v-chip label small :color="item.Status | complain_type_color" text-color="white">{{ item.Status | complain_type}}</v-chip>
                                    </td>
                                    <td class="text-center">
                                        <v-btn v-if="complainRole" small color="primary" @click="gotoComplainDetail(item.ID)">Chi tiết</v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Lich su thay doi -->
            <v-flex sm12 md12 lg12 v-if="orderWidgets.changeHistory">
                <v-widget title="Lịch sử thay đổi">
                    <div slot="widget-content">
                        <v-data-table :headers="changedHistoryHeader" :items="order.ChangedHistories" :mobile-breakpoint="100" :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }" :items-per-page="10">
                            <template  v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.CreatedDate | display_date }}</td>
                                    <td>{{ item.Username}}</td>
                                    <td>{{ item.HistoryContent}}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-widget>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogCancelOrder" max-width="300px">
            <v-card>
                <v-card-title>
                <span class="title">Xác nhận hủy đơn hàng</span>
                </v-card-title>
                <v-card-text>
                <v-container grid-list-md pa-0>
                    <v-layout row wrap>
                        <v-flex lg12>
                            <h-currency-input :disabled="order.Status == statusEnum.da_dat_coc || order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia" label="Tiền hoàn khách" v-model="backAmountVND" :decimal="0"></h-currency-input>
                        </v-flex>
                        <v-flex lg12>
                            <v-select :items="cancel_reason_list" v-model="cancelReason" item-text="name" item-value="value"></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text" @click="dialogCancelOrder = false">Đóng</v-btn>
                <v-btn color="red darken-1 white--text" @click="CancelOrder">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogOtherFee" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="title">Danh sách phí khác</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap v-if="((order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_xuat_kho) || (order.Status != statusEnum.hoan_thanh && (paymentRole || adminRole)))">
                            <v-flex lg6>
                                <v-select :items="other_fee_config" v-model="selectedOtherFee" item-text="name" item-value="value"></v-select>
                            </v-flex>
                            <v-flex lg6 pt-6>
                                <v-btn class="mx-2" small @click="addOtherFeeItem"><v-icon>fa-plus</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12 v-if="otherFees">
                                <v-data-table :headers="otherFeeHeader" :items="otherFees" hide-default-footer :mobile-breakpoint="100" :items-per-page="20">
                                    <template  v-slot:item="{ item }">
                                        <tr>
                                            <td>{{ item.FeeName }}</td>
                                            <td class="text-end" v-if="(order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_xuat_kho) || (order.Status != statusEnum.hoan_thanh && (paymentRole || adminRole))">
                                                <v-edit-dialog :return-value.sync="item.Amount" large lazy persistent @save="updateOtherFeeItem({'ID': item.ID, 'Amount': item.Amount})">
                                                    <div>{{ item.Amount | currency}}</div>
                                                    <template v-slot:input>
                                                        <h-currency-input label="Tiền phí" v-model="item.Amount" :decimal="0" :autoEmit="true"></h-currency-input>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td v-else>{{ item.Amount | currency}}</td>
                                            <td v-if="(order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_thanh_toan) || (!lockedOrder && (paymentRole || adminRole))">
                                                <v-edit-dialog :return-value.sync="item.Note" large lazy persistent @save="updateOtherFeeItem({'ID': item.ID, 'Note': item.Note})">
                                                    <div>{{ item.Note }}</div>
                                                    <template v-slot:input>
                                                        <v-text-field label="Ghi chú" v-model="item.Note"></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="text-center"><v-icon medium @click="deleteOtherFeeItem(item.ID)" v-if="(order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_xuat_kho) || (order.Status != statusEnum.hoan_thanh && (paymentRole || adminRole))">delete</v-icon></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1 white--text" @click="dialogOtherFee = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <voucher-popup :modalDialog="voucherPopup" :order_id="order.ID" :order_type="1" :uid="order.UID" :user_name="order.Username" order_code="MD" @closePopup="voucherPopup = false"></voucher-popup>
        <v-dialog v-model="dialogNewDeposit" max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="title">Tạo mới đơn hàng ký gửi</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-form ref="entryForm">
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <p class="body-2 font-weight-bold text-red">Danh sách vận đơn (Số lượng: {{newOrder.TransactionCodes.length}})</p>
                                    <v-list>
                                        <v-list-item v-for="(item, index) in newOrder.TransactionCodes" :key="item.ID">
                                            <v-list-item-content>
                                                <v-flex lg4 md4 sm12 xs12>
                                                    <v-text-field label="Mã vận đơn" v-model="item.TransactionCode"></v-text-field>
                                                </v-flex>
                                                <v-flex lg4 md4 sm12 xs12>
                                                    <v-text-field label="Tên hàng hoá" v-model="item.ProductName"></v-text-field>
                                                </v-flex>
                                                <v-flex lg2 md2 sm12 xs12>
                                                    <h-currency-input label="Giá trị(¥)" :decimal="1" v-model="item.ProductAmount"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg2 md2 sm12 xs12>
                                                    <h-currency-input label="Số kiện" :decimal="0" v-model="item.NumberOfPack"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg12 md12 sm12 xs12>
                                                    <v-textarea v-model="item.OrderNote" background-color="#fefefe" dense rows="3" outlined label="Ghi chú"></v-textarea>
                                                </v-flex>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                            <v-btn icon @click="newOrder.TransactionCodes.splice(index, 1);">
                                                <v-icon>fa-trash-alt</v-icon>
                                            </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                    <v-layout row wrap>
                                        <v-divider class="ma-0"></v-divider>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <v-text-field label="Mã vận đơn" v-model="newTransaction.TransactionCode"></v-text-field>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <v-text-field label="Tên hàng hoá" v-model="newTransaction.ProductName"></v-text-field>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <h-currency-input label="Giá trị(¥)" :decimal="1" v-model="newTransaction.ProductAmount"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <h-currency-input label="Số kiện" :decimal="0" v-model="newTransaction.NumberOfPack"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <h-currency-input label="Số kiện tương tự" :decimal="0" v-model="newTransaction.SameNumberOfPack"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12 xs12>
                                            <v-btn icon large @click="appendTransactionCode"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1 white--text" @click="dialogNewDeposit = false">Đóng</v-btn>
                    <v-btn color="red darken-1 white--text" @click="createNewDeposit">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogChangeCustomer" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="title">Đổi thông tin khách hàng</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-form ref="entryForm">
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-autocomplete label="Khách hàng" v-model="newCusomerID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1 white--text" @click="dialogChangeCustomer = false">Đóng</v-btn>
                    <v-btn color="red darken-1 white--text" @click="updateOrder({OrderID: order.ID, UID: newCusomerID})">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";
// import OrderWidget from "@/components/widgets/OrderWidget";
import OrderTransaction from "@/components/widgets/OrderTransaction";
import OrderFlag from "@/components/widgets/OrderFlag";
import voucher from "@/components/popups/voucher";
import { sendErrorNotice, sendSuccessNotice, makeid, proxyImage } from "@/commons/utils";
import {
    mapState
} from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import {
    payment_type,
    payment_type_color,
    complain_type,
    complain_type_color
} from "@/commons/hpod";
import firebase from 'firebase';

export default {
    filters: {
        payment_type,
        payment_type_color,
        complain_type,
        complain_type_color,
        payment_method: function (value) {
            return value == 1 ? "Trực tiếp" : "Ví điện tử";
        },
    },
    components: {
        VWidget,
        MessageBox,
        // 'order-widget-menu': OrderWidget,
        'order-flag-menu': OrderFlag,
        'order-transaction': OrderTransaction,
        'voucher-popup': voucher
    },
    data() {
        return {
            proxyImage: proxyImage,
            extraOptions: '',
            newCusomerID: 0,
            dialogChangeCustomer: false,
            voucherPopup: false,
            selectedOtherFee: 0,
            isCheckPackageA: false,
            isCheckPackageB: false,
            imageData: null,
            hideImage: false,
            ignoreUpdate: false,
            productSelectedIndex: -1,
            statusEnum: configs.ORDER_STATUS_ENUM,
            pushingToXadal: false,
            feeshiptypes: configs.ORDER_FEESHIP_TYPES,
            tempOrder: {},
            showCustomerDetail: false,
            MinDepositRequest: null,
            dialogProduct: false,
            dialogAppendProduct: false,
            dialogDeposit: false,
            dialogOtherFee: false,
            message: "",
            timeout: 100000,
            events: [],
            input: null,
            nonce: 0,
            search: "",
            editedProIndex: -1,
            payment_status: configs.PAYMENT_STATUS_LIST,
            requireRealMoney: [
                v => parseFloat(v.replace(/[^\d\.\-]/g, "")) > 0 || this.order.Status == this.statusEnum.cho_bao_gia || this.order.Status == this.statusEnum.cho_dat_coc  || this.order.Status == this.statusEnum.da_dat_coc || this.order.Status == this.statusEnum.huy || "Trường dữ liệu không được để trống.",
                v => parseFloat(v.replace(/[^\d\.\-]/g, "")) <= parseFloat((this.order.AmountCNY + this.order.FeeShipCN).toFixed(2)) || 'Tiền mua thật không được lớn hơn tổng giá sản phẩm'
                ],
            editedPro: {
                quantity: 0,
                price: 0,
                comment: ''
            },
            orderEditable: {
                OrderID: 0,
                SalerID: 0,
                CustomerServiceID: 0,
                BuyerID: 0,
                AmountCNY: 0,
                AmountVND: 0,
                ExchangeRate: 0,
                TotalRealAmountCNY: 0,
                FeeShipCN: 0,
                FeeBuy: 0,
                FeeBuyDiscount: 0,
                FeeWeight: 0,
                FeeWeightDiscount: 0,
                FeeOther: 0,
                FeeOtherNote: '',
                ChinaStoreID: 0,
                ReceivePlaceID: 0,
                IsFragileGoods: false,
                FragileFee: 0,
                FragileFeeVND: 0,
                IsCheck: false,
                CheckFeeType: 0,
                CheckFee: 0,
                CheckFeeVND: 0,
                IsFast: false,
                FastFee: 0,
                FastFeeVND: 0,
                GuaranteeType: 0,
                Deposit: 0,
                MinDeposit: 0,
                DiscountVND: 0,
                MinDepositRequest: null,
                WeChatId: null,
                FeeShipType: 0,
                IsUpdateFeeShip: 0,
                BackAmountVND: 0,
                FixListedFeeWeight: 0,
                ListedFeeWeight: 0,
                FixFragileFee: 0,
                FixGuaranteeFee: 0,
                GuaranteeAmountVND: 0,
                ProductType: 0,
                OtherFeeObj: null,
                FeeShipVN: null,
                CheckPayment: 0,
                IsFoam: 0,
                FixFoamFee: 0,
                FoamFee: 0,
                FoamFeeVND: 0,
                SafeLevelID: 0,
                FeeWeightCommission: 0,
                FixFeeWeightCommission: 0
            },
            dialogCancelOrder: false,
            backAmountVND: 0,
            cancelReason: 2,
            totalRealAmount: 0,
            feeShipCNY: 0,
            totalRealAmountCNY: 0,
            otherFeeHeader: [
                {
                    text: "Loại phí",
                    sortable: false
                },
                {
                    text: "Số tiền",
                    sortable: false,
                    align: "end"
                },
                {
                    text: "Ghi chú",
                    sortable: false,
                },
                {
                    text: "",
                    sortable: false,
                    align: "center"
                }
            ],
            paymentHistoryHeader: [{
                    text: "Ngày thanh toán",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Loại thanh toán",
                    value: "Status",
                    sortable: false
                },
                {
                    text: "Hình thức thanh toán",
                    value: "Type",
                    sortable: false
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    sortable: false,
                    align: "end"
                }
            ],
            changedHistoryHeader: [{
                    text: "Ngày thay đổi",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Người thay đổi",
                    value: "Username",
                    sortable: false
                },
                {
                    text: "Nội dung",
                    value: "HistoryContent",
                    sortable: false
                }
            ],
            paymentComplainHeader: [{
                    text: "ID",
                    value: "ID",
                    sortable: false
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    sortable: false,
                    align: "end"
                },
                {
                    text: "Nội dung",
                    value: "ComplainText",
                    sortable: false
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    sortable: false
                },
                {
                    text: "Thao tác",
                    align: "center",
                    value: "",
                    sortable: false
                }
            ],
            productHeader: [{
                    text: "TT",
                    value: "index",
                    sortable: false
                },
                {
                    text: "ID",
                    value: "ID",
                    sortable: false
                },
                {
                    text: "Ảnh",
                    value: "image_origin",
                    sortable: false
                },
                {
                    text: "Thuộc tính",
                    value: "property",
                    sortable: false
                },
                {
                    text: "Số lượng",
                    value: "quantity",
                    align: "end",
                    sortable: false
                },
                {
                    text: "Giá (¥)",
                    value: "price_promotion",
                    align: "end",
                    sortable: false
                },
                {
                    text: "Thành tiền (¥)",
                    value: "total",
                    align: "end",
                    sortable: false
                },
                {
                    text: "",
                    align: "center",
                    sortable: false
                }
            ],
            newProduct: {
                Link: '',
                Image: '',
                Property: '',
                Price: 0,
                Quantity: 1
            },
            price_type_enum: configs.PRICE_TYPE_ENUM,
            newProducts: [],
            newTransaction: {
                TransactionCode: '',
                VbiCode: '',
                Status: 1,
                UID: 0,
                OrderID: 0,
                PackageType: 1,
                OrderNote: '',
                ProductName: '',
                ProductAmount: 0,
                NumberOfPack: 0
            },
            newOrder: {
                UID: 0,
                Status: 16,
                PriceType: 1,
                NumberOfPack: 0,
                ReceiveAddress: '',
                TransactionCodes: []
            },
            dialogNewDeposit: false,
        };
    },
    computed: {
        orderId() {
            return Number(this.$route.params.Pid);
        },
        orderStatus() {
            return configs.ORDER_STATUS;
        },
        remainAmount() {
            if (this.order && this.order.QuotationID > 0) {
                return 0;
            }
            return this.order.TotalAmountVND - this.order.Deposit;
        },
        totalProduct() {
            return _.sumBy(this.products, 'quantity');
        },
        cancel_reason_list() {
            return _.filter(configs.CANCEL_REASON, {'disabled': false});
        },
        customerView() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        canReorder() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.huy;
        },
        orderReady() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc;
        },
        orderCancelable() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia;
        },
        orderPaymentReady() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_nhap_kho_nhan;
        },
        orderNotDeposit() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc;
        },
        orderLocked() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.huy || this.order.Status == configs.ORDER_STATUS_ENUM.khieu_nai;
        },
        confirmPrice() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia;
        },
        orderReadonly() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.huy || this.order.Status == configs.ORDER_STATUS_ENUM.hoan_thanh || this.order.Status == configs.ORDER_STATUS_ENUM.khieu_nai;
        },
        orderRole() {
            return this.$store.state.authentication.role.Orders;
        },
        orderEditRole() {
            return this.$store.state.authentication.role.OrderEditable;
        },
        productEditable() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia  || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl);
        },
        lockedOrder() {
            return (this.order.Status == configs.ORDER_STATUS_ENUM.hoan_thanh || this.order.Status == configs.ORDER_STATUS_ENUM.da_xuat_kho) && !(this.paymentRole || this.adminRole);
        },
        complainRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase);
        },
        realAmountRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        purchaseRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        csRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        saleRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService && (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        },
        internalRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        totalWeight() {
            return _.sumBy(this.transCodes, (o) => {return (o.Weight > o.WeightByVolume ?  o.Weight : o.WeightByVolume)*10})/10;
        },
        // totalVolume() {
        //     return Math.round(_.sumBy(this.transCodes, (o) => {return (o.Length*o.Width*o.Height/1000000)}) * 100)/100;
        // },
        // totalVolume() {
        //     return _.sumBy(this.transCodes, (o) => {return o.Volume});
        // },
        totalVolume() {
            if(!this.transCodes) {
                return 0;
            }
            // Nhóm 1: Có Packages
            const withPackages = this.transCodes.filter(o => o.Packages && o.Packages.length > 0);
            // Nhóm 2: Không có Packages
            const withoutPackages = this.transCodes.filter(o => !o.Packages || o.Packages.length === 0);

            const totalWithPackages = _.sumBy(withPackages, o => o.Volume || 0);
            const totalWithoutPackages = Math.round(_.sumBy(withoutPackages, o => (o.Length * o.Width * o.Height / 1000000)) * 100) / 100;

            return totalWithPackages + totalWithoutPackages;
        },
        totalWeightByBigpackage() {
            if(!this.totalWeight && !this.totalVolume) {
                const groupByBigpackage = _.map(_.groupBy(this.transCodes, 'BigPackageID'), (items, BigPackageID) => ({
                    'BigPackageID': BigPackageID,
                    'TotalWeight': items[0].BigpackageWeight  // lấy weight của phần tử đầu tiên
                }));
                return _.sumBy(groupByBigpackage, (o) => {return o.TotalWeight*10})/10;
            }
            return 0;
        },
        totalVolumeByBigpackage() {
            if(!this.totalWeight && !this.totalVolume) {
                const groupByBigpackage = _.map(_.groupBy(this.transCodes, 'BigPackageID'), (items, BigPackageID) => ({
                    'BigPackageID': BigPackageID,
                    'TotalVolume': items[0].BigpackageVolume  // lấy Volume của phần tử đầu tiên
                }));
                return _.sumBy(groupByBigpackage, (o) => {return o.TotalVolume*100})/100;
            }
            return 0;
        },
        ...mapState({
            configuration: state => state.configuration.selected,
            order: state => state.main_order.selectedOrder,
            customer: state => state.main_order.selectedOrder.Customer,
            products: state => state.main_order.selectedOrder.Products.map((items, index) => ({...items, index: index + 1 })),
            staffs: state => state.commons.all_users,
            p_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            }),
            sale_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService && (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            }),
            cs_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
            }),
            customers: state => state.customer.master.data,
            vipLevels: state => state.customerLevel.all.data,
            warehouses: state => state.commons.stores,
            chinaStores: state => state.commons.chinaStores,
            allFlags: state => state.orderFlag.all.data,
            guarantees: state => {
                let tmp = [{PackageName: 'Không sử dụng', ID: 0}];
                if(state.feeGuarantee.all.data) {
                    state.feeGuarantee.all.data.forEach(element => {
                        if (!element.IsExport) {
                            tmp.push(element);
                        }
                    });
                }
                return tmp;
            },
            transCodes: state => state.orderTransaction.all.data,
            vouchers: state => state.customer.vouchers,
            otherFees: state => state.orderFee.all.data,
            safeLevels: state => state.safeLevel.safe_level_by_store,
        }),
        ...mapState("main_order", {
            loading: "loading",
        }),
        ...mapState("commons", {
            orderWidgets: "orderWidgetSettings",
        }),
        ...mapState("orderTransaction", {
            weightEdited: "edited",
        }),
        product_types() {
            return this.configuration && this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
        other_fee_config() {
            let tmp = this.configuration && this.configuration.OtherFeeObj ? JSON.parse(this.configuration.OtherFeeObj) : [];
            return _.filter(tmp, {'ignore': 0});
        },
        feeWeightCommissionRate() {
            let tmp = this.configuration && this.configuration.FeeWeightCommissionRates ? JSON.parse(this.configuration.FeeWeightCommissionRates) : [];
            return _.find(tmp, {'warning': 1});
        },
        existExported() {
            let tmp = _.filter(this.transCodes, (o) => {return o.Status == configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN});
            return tmp.length > 0;
        },
        warningFeeWeight() {
            if(this.feeWeightCommissionRate && this.feeWeightCommissionRate.max <= (this.order.FeeWeight-this.order.ListedFeeWeight)/this.order.FeeWeight*100 && !this.order.CheckPayment) {
                return true;
            }
            return false;
        },
        diffChinaStoreID() {
            let tmp = _.filter(this.transCodes, (o) => {return o.SelfChinaStoreID && o.SelfChinaStoreID != this.order.ChinaStoreID});
            return tmp.length > 0;
        },
        diffUID() {
            let tmp = _.filter(this.transCodes, (o) => {return o.StoreUID && o.StoreUID != this.order.UID});
            return tmp.length > 0;
        },
        missingPackage() {
            return _.some(this.transCodes, (o) => {return o.MissingPackage == 1 || (o.NumberOfPack > o.RealNumberOfPack && o.Packages && o.Packages.length > 0)});
        }
    },
    watch: {
        orderId() {
            this.refreshData();
        },
        weightEdited() {
            if (this.weightEdited) {
                this.refreshData();
            }
        },
        order() {
            this.extraOptions = this.order.SafeLevelID ? 'safe-level' : 'optional';
            this.ignoreUpdate = true;
            this.orderEditable = this.getOrderEditable();
            this.totalRealAmount = this.order.TotalRealAmount;
            this.feeShipCNY = this.order.FeeShipCN;
            this.totalRealAmountCNY = this.order.TotalRealAmountCNY;
            setTimeout(() => {
                this.ignoreUpdate = false;
                this.$store.dispatch("customer/getCustomerVoucher", {id: this.order.UID, order_id: this.order.ID, order_type: 1});
            }, 1000);
            if(this.order.ChinaStoreID) {
                this.$store.dispatch("safeLevel/get_safe_level_by_store", this.order.ChinaStoreID);
            }
        },
        orderEditable: {
            handler: function (newVal, oldVal) {
                if(!this.ignoreUpdate) {
                    this.updateOrderDetail(newVal, oldVal);
                }
            },
            deep: true,
            immediate: true
        },
        isCheckPackageA() {
            if(this.isCheckPackageA) {
                this.isCheckPackageB = false;
                this.orderEditable.IsCheck = 1;
                this.orderEditable.CheckFeeType = 1;
            }
            if(!this.isCheckPackageA && !this.isCheckPackageB) {
                this.orderEditable.IsCheck = 0;
                this.orderEditable.CheckFeeType = 0;
            }
        },
        isCheckPackageB() {
            if(this.isCheckPackageB) {
                this.isCheckPackageA = false;
                this.orderEditable.IsCheck = 1;
                this.orderEditable.CheckFeeType = 2;
            }
            if(!this.isCheckPackageA && !this.isCheckPackageB) {
                this.orderEditable.IsCheck = 0;
                this.orderEditable.CheckFeeType = 0;
            }
        },
    },
    methods: {
        getOrderEditable() {
            this.isCheckPackageA = this.order.IsCheck && this.order.CheckFeeType == 1;
            this.isCheckPackageB = this.order.IsCheck && this.order.CheckFeeType == 2;
            return {
                OrderID: this.order.ID,
                SalerID: this.order.SalerID,
                CustomerServiceID: this.order.CustomerServiceID,
                BuyerID: this.order.BuyerID,
                TotalRealAmountCNY: this.order.TotalRealAmountCNY,
                FeeShipCN: this.order.FeeShipCN,
                FeeShipCNVND: this.order.FeeShipCNVND,
                ExchangeRate: this.order.ExchangeRate,
                FeeBuy: this.order.FeeBuy,
                FeeBuyDiscount: this.order.FeeBuyDiscount,
                FeeBuyAmount: this.order.FeeBuyAmount,
                FeeWeight: this.order.FeeWeight,
                FeeWeightDiscount: this.order.FeeWeightDiscount,
                FeeWeightAmount: this.order.FeeWeightAmount,
                FeeOther: this.order.FeeOther,
                FeeOtherNote: this.order.FeeOtherNote,
                ChinaStoreID: this.order.ChinaStoreID,
                ReceivePlaceID: this.order.ReceivePlaceID,
                IsFragileGoods: this.order.IsFragileGoods,
                FragileFee: this.order.FragileFee,
                FragileFeeVND: this.order.FragileFeeVND,
                IsCheck: this.order.IsCheck,
                CheckFeeType: this.order.CheckFeeType,
                CheckFee: this.order.CheckFee,
                CheckFeeVND: this.order.CheckFeeVND,
                IsFast: this.order.IsFast,
                FastFee: this.order.FastFee,
                FastFeeVND: this.order.FastFeeVND,
                Deposit: this.order.Deposit,
                DiscountVND: this.order.DiscountVND,
                GuaranteeType: this.order.GuaranteeType,
                GuaranteeAmountVND: this.order.GuaranteeAmountVND,
                MinDeposit: this.order.MinDeposit,
                MinDepositRequest: this.order.MinDepositRequest,
                WeChatId: this.order.WeChatId,
                FeeShipType: this.order.FeeShipType,
                IsUpdateFeeShip: this.order.IsUpdateFeeShip,
                BackAmountVND: this.order.BackAmountVND,
                FixListedFeeWeight: this.order.FixListedFeeWeight,
                ListedFeeWeight: this.order.ListedFeeWeight,
                FixFragileFee: this.order.FixFragileFee,
                FixGuaranteeFee: this.order.FixGuaranteeFee,
                ProductType: this.order.ProductType,
                OtherFeeObj: this.order.OtherFeeObj,
                FeeShipVN: this.order.FeeShipVN,
                CheckPayment: this.order.CheckPayment,
                IsFoam: this.order.IsFoam,
                FixFoamFee: this.order.FixFoamFee,
                FoamFee: this.order.FoamFee,
                FoamFeeVND: this.order.FoamFeeVND,
                SafeLevelID: this.order.SafeLevelID,
                FeeWeightCommission: this.order.FeeWeightCommission,
                FixFeeWeightCommission: this.order.FixFeeWeightCommission,
            }
        },
        closePanel() {
            this.$router.push({
                name: "OrderList"
            });
        },
        getUserName(id) {
            const obj = this.$store.state.commons.all_users.find(
                obj => obj.ID === id
            );
            return obj ? obj.Username : "";
        },
        getVipValue(id) {
            const item = _.find(this.vipLevels, {'ID': id});
            return item ? item.VIPName : '';
        },
        closeSnackbar() {
            Store.commit("main_order/setSnackbar", {
                snackbar: false
            });
            Store.commit("main_order/setNotice", {
                notice: ""
            });
        },
        refreshData() {
            this.orderEditable.OrderID = 0;
            this.$store.dispatch("commons/getAllUsers");
            this.$store.dispatch("orderFee/getList", {'OrderID': this.orderId, 'OrderType': configs.ORDER_TYPE.order});
            this.$store.dispatch("feeGuarantee/getList");
            this.$store.dispatch("customerLevel/getCustomerLevelList");
            this.$store.dispatch("main_order/getOrderDetail", this.orderId);
        },
        manualUpdateDetail() {
            this.orderEditable.FeeShipCN = this.feeShipCNY;
            this.orderEditable.TotalRealAmountCNY = this.totalRealAmountCNY;
        },
        updateOrderDetail: _.debounce(function (newVal, oldVal) {
            if (oldVal && oldVal.OrderID !== 0) {
                if (newVal.TotalRealAmountCNY !== 0) {
                    newVal.TotalRealAmount =
                        newVal.TotalRealAmountCNY * this.order.ExchangeRate;
                    this.totalRealAmount = newVal.TotalRealAmount;
                }
                // Validate data
                if(parseFloat(newVal.TotalRealAmountCNY.toFixed(2)) > parseFloat((this.order.AmountCNY + this.orderEditable.FeeShipCN).toFixed(2))) {
                    sendErrorNotice("Tiền mua thật không được lớn hơn tổng giá sản phẩm!");
                    this.totalRealAmountCNY = 0;
                    return;
                }
                // if(newVal.FeeWeight < newVal.ListedFeeWeight) {
                //     sendErrorNotice("Giá bán không được nhỏ hơn giá niêm yết!");
                //     return;
                // }
                if(!_.isEqual(newVal, this.tempOrder)){
                    if(this.order.MinDeposit != this.orderEditable.MinDeposit) {
                        newVal.IgnoreCalc = 1;
                    }
                    let updateObject = {OrderID: newVal.OrderID};
                    for (const prop in newVal) {
                        if(newVal[prop] != this.order[prop]) {
                            updateObject[prop] = newVal[prop];
                            if(prop == 'SafeLevelID') {
                                updateObject[prop] = updateObject[prop] != null ? updateObject[prop] : 0; 
                            }
                        }
                    }
                    this.$store.dispatch("main_order/updateOrderDetail", updateObject);
                    this.tempOrder = _.cloneDeep(newVal);
                }
            }
        }, 1000),
        depositRequest() {
            this.dialogDeposit = true;
        },
        editProduct(item) {
            // this.editedProIndex = index;
            this.editedPro = Object.assign({}, item);
            this.dialogProduct = true;
        },
        appendProductShow() {
            this.dialogAppendProduct = true;
        },
        removeProduct(item) {
            window.getApp.$emit("REQUEST_DELETE_DATA", item, `Bạn thực sự muốn xoá sản phẩm ?`);
        },
        closeProductDialog() {
            this.dialogProduct = false;
        },
        saveProduct() {
            this.editedPro.OrderID = this.orderId;
            this.$store.dispatch("main_order/updateProduct", this.editedPro).then(() => {
                this.refreshData();
                this.dialogProduct = false;
            });
        },
        gotoComplainDetail(id) {
            let routeData = this.$router.resolve({
                path: `/khieu-nai/don-hang/${id}`,
                params: {
                Pid: id,
                title: `Chi tiết khiếu nại (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        get_type_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        ReOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.huy) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_dat_coc});
            }
            else {
                sendErrorNotice("Không thể lên lại đơn hàng!");
            }
        },
        CancelOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia || this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || this.adminRole) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.huy, BackAmountVND: this.backAmountVND, CancelReason: this.cancelReason});
                this.dialogCancelOrder = false;
            }
            else {
                sendErrorNotice("Không thể hủy đơn hàng!");
            }
        },
        WaitPayOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_dat_coc});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        DepositOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, UID: this.order.UID, Status: configs.ORDER_STATUS_ENUM.da_dat_coc, Deposit: this.order.MinDeposit, ActionType: 'DepositOrder'});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        updateOrder(item) {
            const cust = _.find(this.customers, {'ID': item.UID});
            if(cust) {
                item.Username = cust.Username;
            }
            this.$store.dispatch("main_order/updateOrderDetail", item);
            this.dialogChangeCustomer = false;
        },
        CreateDeposit() {
            this.dialogNewDeposit = true;
        },
        appendTransactionCode() {
            if(this.newTransaction.TransactionCode == '') {
                sendErrorNotice("Mã vận đơn không được để trống!");
                return;
            }
            this.newOrder.TransactionCodes.push({...this.newTransaction});
            if(this.newTransaction.SameNumberOfPack) {
                let tran_code = this.newTransaction.TransactionCode;
                for (let i = 0; i < this.newTransaction.SameNumberOfPack - 1; i++) {
                    this.newTransaction.TransactionCode = tran_code + '_' + (i+2)
                    this.newOrder.TransactionCodes.push({...this.newTransaction});
                }
            } 
            
            this.newTransaction = {
                TransactionCode: '',
                VbiCode: '',
                Status: 1,
                UID: 0,
                OrderID: 0,
                PackageType: 1,
                OrderNote: '',
                ProductName: '',
                ProductAmount: 0,
                NumberOfPack: 0,
                GuaranteeRate: 0
            }
        },
        createNewDeposit() {
            if (!this.$refs.entryForm.validate()){
                return;
            }
            if(this.newOrder.PriceType == this.price_type_enum.don_thuong && this.newOrder.TransactionCodes.length == 0) {
                sendErrorNotice("Hãy nhập danh sách mã vận đơn!");
                return;
            }
            if(this.newOrder.PriceType == this.price_type_enum.gui_nguoc) {
                for (let i = 0; i < this.newOrder.NumberOfPack; i++) {
                    this.newOrder.TransactionCodes.push({...this.newTransaction, VbiCode: Math.random().toString(36).slice(2, 10)})
                }
            }
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.newOrder.ParentID = this.order.ID;
            this.newOrder.UID = this.order.UID;
            this.newOrder.Username = this.order.Username;
            this.newOrder.ChinaStoreID = this.order.ChinaStoreID;
            this.newOrder.ReceivePlaceID = this.order.ReceivePlaceID;

            this.$store.dispatch("deposit/setDetail", {'data': this.newOrder, 'params': param});
            this.newOrder = {
                UID: 0,
                Status: 16,
                ReceiveAddress: '',
                TransactionCodes: []
            };
            this.dialogNewDeposit = false;
            sendSuccessNotice('Tạo mới đơn hàng thành công.');
        },
        openCustomerDetail: function() {
            this.showCustomerDetail = !this.showCustomerDetail;
        },
        gotoCustomerDetail: function(id) {
            let routeData = this.$router.resolve({
                name: "CustomerDetail",
                params: {
                Pid: id,
                title: `Khách hàng (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        appendProduct() {
            this.newProduct.OrderID = this.order.ID;
            this.newProduct.UID = this.order.UID;
            this.newProducts.push(this.newProduct);
            this.newProduct = {
                Link: '',
                Image: '',
                Property: '',
                Price: 0,
                Quantity: 1
            }
        },
        createNewOrder() {
            if(this.newProducts.length == 0) {
                sendErrorNotice("Hãy nhập danh sách sản phẩm!");
                return;
            }
            this.$store.dispatch("main_order/createNewLink", {'data': {'Products': this.newProducts}, 'id': this.order.ID });
            this.newProducts = [];
            this.dialogAppendProduct = false;
            sendSuccessNotice('Thêm mới link sản phẩm thành công.');
        },
        chooseImage(item) {
            this.newProduct.Image = '';
            this.$refs.fileInput.click();
        },
        previewImage(event) {
            this.imageData = event.target.files[0];
            this.$refs.fileInput.value = null;
            this.onUpload()
        },
        onUpload() {
            const arrFileType = this.imageData.name.split('.');
            const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
            storageRef.on(`state_changed`, snapshot => {
                    
                },
                error => {
                sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
                },
                () => {
                    storageRef.snapshot.ref.getDownloadURL().then((url) => {
                        this.newProduct.Image =url;
                        this.hideImage = true;
                        this.$nextTick(() => this.hideImage = false);
                    });
                }
            );
        },
        getImages(index) {
            return this.newProducts[index].Image;
        },
        openOtherFeePopup() {
            this.dialogOtherFee = true;
        },
        updateOtherFeeItem(item) {
            this.$store.dispatch("orderFee/setDetail", {
                data: item,
                id: item.ID
            });
        },
        deleteOtherFeeItem(id) {
            this.$store.dispatch("orderFee/removeDetail", id);
        },
        addOtherFeeItem() {
            if(!this.selectedOtherFee) {
                sendErrorNotice("Hãy chọn loại phí cho đơn hàng.");
                return;
            }
            if(_.find(this.otherFees, {'FeeType': this.selectedOtherFee})) {
                sendErrorNotice("Loại phí đã tồn tại trên đơn hàng.");
                return;
            }
            const tmp = _.find(this.other_fee_config, {'value': this.selectedOtherFee});
            this.$store.dispatch("orderFee/setDetail", {
                data: {
                    OrderID: this.order.ID,
                    OrderType: configs.ORDER_TYPE.order,
                    FeeType: tmp.value,
                    FeeName: tmp.name,
                    Amount: 0
                },
                id: 0
            });
        },
        openDialogCustomerChange() {
            this.getCustomerList();
            this.dialogChangeCustomer = true;
        },
        getCustomerList() {
            let payload = {
                is_master: 1,
                filter: [],
                fields: ["ID", "Username", "BuyerID", "CustomerServiceID", "SaleID"]
            };
            
            if(this.order.SalerID == this.$store.state.authentication.user.userid) {
                payload.filter.push({
                    column: "SaleID",
                    value: this.$store.state.authentication.user.userid,
                    condition: "equal",
                });
            }
            this.$store.dispatch("customer/getCustomerList", payload);
        },
        createExtendDeposit() {
            this.newOrder.TransactionCodes = [];
            for (let i = 0; i < this.transCodes.length; i++) {
                this.newOrder.TransactionCodes.push({TransactionCode: `${this.transCodes[i].TransactionCode}-bs`, PackageType: 1, Status: 3, NumberOfPack: 1, RealNumberOfPack: 1, CreatedBy: this.$store.state.authentication.user.username})
            }
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.newOrder.ParentID = this.order.ID;
            this.newOrder.UID = this.order.UID;
            this.newOrder.Username = this.order.Username;
            this.newOrder.ChinaStoreID = this.order.ChinaStoreID;
            this.newOrder.ReceivePlaceID = this.order.ReceivePlaceID;

            this.$store.dispatch("deposit/setDetail", {'data': this.newOrder, 'params': param}).then((p) => {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: p.data.ID,
                        title: `Chi tiết đơn hàng (#${p.data.ID})`
                    }
                });
                window.open(routeData.href, "_blank");
            }).catch((error) => {
                sendErrorNotice("Không thể nhân bản đơn hàng: " + error.message);
            });
            this.newOrder = {
                UID: 0,
                Status: 16,
                ReceiveAddress: '',
                TransactionCodes: []
            };
        },
        pushToXadal() {
            if (confirm("Bạn có chắc chắn muốn đẩy đơn hàng này lên giỏ hàng Xadal?")) {
                this.pushingToXadal = true;
                window.getApp.$emit("APP_REQUEST_START");
                this.$store.dispatch('main_order/pushToXadal', {
                    OrderID: this.orderId
                }).then(response => {
                    this.pushingToXadal = false;
                    window.getApp.$emit("APP_REQUEST_SUCCESS");
                    if (response.data.data && response.data.data.success) {
                        sendSuccessNotice(response.data.data.msg);
                    } else {
                        sendErrorNotice(response.data.reason || "Lỗi không xác định");
                    }
                }).catch(error => {
                    this.pushingToXadal = false;
                    window.getApp.$emit("APP_REQUEST_SUCCESS");
                    sendErrorNotice("Lỗi hệ thống: " + (error.data && error.data.reason ? error.data.reason : error.message));
                });
            }
        }
        
    },
    mounted() {
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllChinaStores");
        this.$store.dispatch("configuration/getDetail", 1);
        this.refreshData();
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
            this.$store.dispatch("main_order/removeProduct", {id: item.ID, OrderID: item.OrderID}).then(() => {
                this.refreshData();
            });
        });
        this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
            if(action == 'editNumberOfPack') {
                this.createExtendDeposit();
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_ACTION");
    }
};
</script>

<style scoped>
.product-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.v-list--two-line .v-list__tile {
    height: auto !important;
    padding: 5px 0 5px 0;
}

.theme--light.red--text.v-input--is-disabled input {
    color: #f44336 !important;
    caret-color: #f44336 !important;
}

.image-product {
    width: 64px;
}

.theme--light.v-data-table tbody tr td .text-red,
.text-red .v-select__selection,
.text-red .v-icon.v-icon {
    color: #a77800!important;
}
.product-highlight-row {
    background-color: bisque;
}
.warning-amount {
    background-color: #ffc5c5;
}
</style>
